/** @format */

import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

function BankAccountNumber(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
    />
  );
}

BankAccountNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const FormattedInputs = ({ myBankAccount, setMyBankAccount }) => {
  const handleChange = (event) => {
    setMyBankAccount(event.target.value);
  };

  return (
    <div>
      <FormControl className="w-full my-3">
        {/* <InputLabel htmlFor="formatted-text-mask-input1">계좌번호</InputLabel> */}
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          계좌번호
        </InputLabel>
        <Input
          value={myBankAccount}
          onChange={handleChange}
          name="textmask"
          id="formatted-text-mask-input1"
          inputComponent={BankAccountNumber}
        />
      </FormControl>
    </div>
  );
};
export default FormattedInputs;
